import { BrowserRouter, Routes, Route, Switch } from "react-router-dom";
import Inicio from './components/Inicio/Inicio';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Transparencia from './components/Transparencia/Transparencia';
import Rubros from './components/Rubros/Rubros';
import DetalleRubro from './components/DetalleRubro/DetalleRubro';
import RubrosHistoricos from "./components/RubrosHistoricos/RubrosHistoricos";
import Agenda from "./components/Agenda/Agenda";
import Error404 from "./components/Error404/Error404";
import Tramites from './components/Tramites/Tramites';
import Programas from './components/Programas/Programas';
import Directorio from './components/Directorio/Directorio';
import Licitaciones from './components/Licitaciones/Licitaciones';
import Enajenacion from './components/Enajenacion/Enajenacion';
import Convenios from './components/Convenios/Convenios';
import Museo from './components/Museo/Museo';
import PAAAS from './components/PAAAS/PAAAS';
import PADA from './components/PADA/PADA';
import OyRI from './components/OyRI/OyRI';
import Consultorios from './components/Consultorios/consultorios';
import ProtocoloCero from './components/ProtocoloCero/ProtocoloCero';
import CEPCI from './components/CEPCI/cepci';
import Cedulas from './components/Cedulas/Cedulas';
import Convocatorias from './components/Convocatorias/convocatorias';
import Examenes from './components/Examenes/Examenes';
import Escribano from './components/Escribano/Escribano';
import Adquisiciones from './components/Adquisiciones/Adquisiciones';
import Poa from './components/Poa/Poa';


function App() {
  return (
    <BrowserRouter>
      <Header/>
        <Routes>
          <Route exact path="/" element={ <Inicio /> } />
          <Route exact path="/transparencia" element={<Transparencia/>} />
          <Route exact path="/Agenda" element={ <Agenda/> } />
          <Route exact path="/Tramites" element={ <Tramites/> } />
          <Route exact path="/Programas" element={ <Programas/> } />
          <Route exact path="/Directorio" element={ <Directorio/> } />
          <Route exact path="/Convenios" element={ <Convenios/> } />
          <Route exact path="/Licitaciones" element={ <Licitaciones/> } />
          <Route exact path="/Enajenacion" element={ <Enajenacion/> } />
          <Route exact path="/Museo" element={ <Museo/> } />
          <Route exact path="/Transparencia/Rubros" element={ <Rubros/> } />
          <Route exact path="/Transparencia/Rubros/DetalleRubro/:nombre" element={ <DetalleRubro/> } />
          <Route exact path="/Transparencia/Rubros/RubrosHistoricos" element={ <RubrosHistoricos/> } />
          <Route exact path="/Transparencia/PAAAS" element={ <PAAAS/> } />
          <Route exact path="/Transparencia/PADA" element={ <PADA/> } /> 
          <Route exact path="/Transparencia/OyRI" element={ <OyRI/> } />
          <Route exact path="/Consultorios" element={ <Consultorios/> } />
          <Route exact path="/ProtocoloCero" element={ <ProtocoloCero/> } />
          <Route exact path="/CEPCI" element={ <CEPCI/> } />
          <Route exact path="/ProtocoloCero/Cedulas" element={ <Cedulas/> } />
          <Route exact path="/ProtocoloCero/Convocatorias" element={ <Convocatorias/> } />
          <Route exact path="/ProtocoloCero/Examenes" element={ <Examenes/> } />
          <Route exact path="/Escribano" element={ <Escribano/> } />
          <Route exact path="/Adquisiciones" element={ <Adquisiciones/> } />
          <Route exact path="/Poa" element={ <Poa/> } />

          <Route exact path="*" element={<Error404 /> } />
        </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
